//Action
import AllLoginCard from "./AllLoginCard";
import AnimatedImages from "./AnimatedImages";
import LoginCard from "./LoginCard";

function Login() {
  return (
    <>
      <AnimatedImages />
      <AllLoginCard />
    </>
  );
}

export default Login;
